import dayjs from 'dayjs'

export type Gig = {
    date: string // YYYY-MM-DD
    city: string
    venue: string
    note?: string
}

// Add new shows anywhere in this list - they're sorted and split into
// upcoming / past automatically based on today's date.
const gigs: Gig[] = [
    { date: '2026-11-26', city: 'Belfast', venue: 'The Pavillion' },
    { date: '2027-01-16', city: 'Downpatrick', venue: 'Down Arts Centre' },
    { date: '2027-02-25', city: 'Belfast', venue: 'Queens Students Union' },
    { date: '2027-02-26', city: 'Dublin', venue: 'Anseo' },
    { date: '2027-02-27', city: 'Birr', venue: "Craughwell's" },
    { date: '2027-02-28', city: 'Galway', venue: 'TBA' },

    { date: '2026-09-25', city: 'Birr', venue: 'Birr Folk Festival', note: 'Acoustic' },
    { date: '2026-09-26', city: 'Birr', venue: 'Birr Folk Festival', note: 'Acoustic' },
    { date: '2026-06-26', city: 'Belfast', venue: 'Queens Students Union' },
    { date: '2026-05-08', city: 'Dublin', venue: 'Anseo' },
    { date: '2025-10-31', city: 'Belfast', venue: 'The Deers Head' },
    { date: '2025-08-24', city: 'Lisburn', venue: 'Hilden Beer Festival' },
    { date: '2025-05-25', city: 'Belfast', venue: 'The American Bar', note: 'Sold out' },
    { date: '2025-04-16', city: 'Belfast', venue: 'Voodoo' },
    { date: '2025-04-05', city: 'Bangor', venue: "Fealty's", note: 'Solo acoustic' },
]

const today = dayjs().startOf('day')

export const upcomingGigs = gigs
    .filter((gig) => !dayjs(gig.date).isBefore(today))
    .sort((a, b) => a.date.localeCompare(b.date))

export const pastGigs = gigs
    .filter((gig) => dayjs(gig.date).isBefore(today))
    .sort((a, b) => b.date.localeCompare(a.date))
